export default {
  LOGO: {
    key: 'logo',
    label: 'LOGO和系统名称'
  },
  SEARCH_BAR: {
    key: 'search_bar',
    label: '点击搜索框'
  },
  SEARCH_BAR_INQUIRE: {
    key: 'search_bar_Inquire',
    label: '搜索框中查询按钮'
  },
  STATION_LETTER: {
    key: 'station_letter',
    label: '站内信图标'
  },
  MINE: {
    key: 'mine',
    label: '我的下拉按钮'
  },
  MINE_COPY: {
    key: 'mine_copy',
    label: '我的 - PIN右侧复制按钮'
  },
  MINE_MEMBERPOINTS: {
    key: 'mine_memberpoints',
    label: '我的 - 会员积分'
  },
  MINE_MEMBERSHIPVALUE: {
    key: 'mine_membershipvalue',
    label: '我的 - 会员成长值'
  },
  MINE_ELECTRONICCONTRACT: {
    key: 'mine_electroniccontract',
    label: '我的 - 电子合同'
  },
  EACH_MENU: {
    key: 'each_menu',
    label: '各一级和三级菜单均埋点'
  },
  ABNORMALORDER_NUMBER: {
    key: 'abnormalorder_number',
    label: '异常订单 - 异常订单数量TAB'
  },
  ABNORMALORDER_HANDLING: {
    key: 'abnormalorder_handling',
    label: '异常订单 - 异常处理按钮'
  },
  ABNORMALORDER_SEEDETAILS: {
    key: 'abnormalorder_seedetails',
    label: '异常订单 - 查看详情按钮'
  },
  ABNORMALORDER_SEEALL: {
    key: 'abnormalorder_seeall',
    label: '异常订单 - 查看全部按钮'
  },
  ABNORMALORDER_NEGOTIATE_SHUTDOWN: {
    key: 'abnormalorder_negotiate_shutdown',
    label: '异常订单 - 协商再投弹层-关闭按钮'
  },
  ABNORMALORDER_NEGOTIATE_CANCEL: {
    key: 'abnormalorder_negotiate_cancel',
    label: '异常订单 - 协商再投弹层-取消按钮'
  },
  ABNORMALORDER_NEGOTIATE_DETERMINE: {
    key: 'abnormalorder_negotiate_determine',
    label: '异常订单 - 协商再投弹层-确定按钮'
  },
  ABNORMALORDER_NEGOTIATE_APPROVALSTATUS: {
    key: 'abnormalorder_negotiate_approvalstatus',
    label: '异常订单 - 协商再投弹层-点击审批状态下拉'
  },
  ABNORMALORDER_NEGOTIATE_APPROVALCOMMENTS: {
    key: 'abnormalorder_negotiate_approvalcomments',
    label: '异常订单 - 协商再投弹层-触发审批意见输入框'
  },
  ABNORMALORDER_NEGOTIATE_REDIRECT: {
    key: 'abnormalorder_negotiate_redirect',
    label: '异常订单 - 协商再投弹层-改址转寄勾选项'
  },
  ABNORMALORDER_NEGOTIATE_REJECT: {
    key: 'abnormalorder_negotiate_reject',
    label: '异常订单 - 协商再投弹层-再次拒收两个选项'
  },
  CLAIMFORM_NUMBER: {
    key: 'claimform_number',
    label: '理赔单 - 理赔单数量TAB'
  },
  CLAIMFORM_SEEDETAILS: {
    key: 'claimform_seedetails',
    label: '理赔单 - 查看详情按钮'
  },
  PURCHASE_DETAILS: {
    key: 'purchase_details',
    label: '采购异常单 - 查看详情按钮'
  },
  PURCHASE_ALL: {
    key: 'purchase_all',
    label: '采购异常单 - 查看全部按钮'
  },
  CLAIMFORM_SEEALL: {
    key: 'claimform_seeall',
    label: '理赔单 - 查看全部按钮'
  },
  INQUIRYFORM_NUMBER: {
    key: 'inquiryform_number',
    label: '咨询单 - 咨询单数量TAB'
  },
  INQUIRYFORM_SEEDETAILS: {
    key: 'inquiryform_seedetails',
    label: '咨询单 - 查看详情按钮'
  },
  INQUIRYFORM_SEEALL: {
    key: 'inquiryform_seeall',
    label: '咨询单 - 查看全部按钮'
  },
  BILL_NUMBER: {
    key: 'bill_number',
    label: '结算单 - 结算单数量TAB'
  },
  BILL_PAY: {
    key: 'bill_pay',
    label: '结算单 - 支付按钮'
  },
  BILL_WIRETRANSFER: {
    key: 'bill_wiretransfer',
    label: '结算单 - 电汇按钮'
  },
  BILL_SEEDETAILS: {
    key: 'bill_seedetails',
    label: '结算单 - 查看详情按钮'
  },
  BILL_DETERMINE: {
    key: 'bill_determine',
    label: '结算单 - 确认按钮'
  },
  BILL_REJECT: {
    key: 'bill_reject',
    label: '结算单 - 驳回按钮'
  },
  BILL_SEEALL: {
    key: 'bill_seeall',
    label: '结算单 - 查看全部按钮'
  },
  WAYBILLSTATUS_TOTAL: {
    key: 'waybillstatus_total',
    label: '运单状态 - 总量'
  },
  WAYBILLSTATUS_PENDING: {
    key: 'waybillstatus_pending',
    label: '运单状态 - 待取件'
  },
  WAYBILLSTATUS_INTRANSIT: {
    key: 'waybillstatus_intransit',
    label: '运单状态 - 运输中'
  },
  WAYBILLSTATUS_RECEIVED: {
    key: 'waybillstatus_received',
    label: '运单状态 - 已签收'
  },
  WAYBILLSTATUS_REJECT: {
    key: 'waybillstatus_reject',
    label: '运单状态 - 拒收'
  },
  WAYBILLSTATUS_TERMINATION: {
    key: 'waybillstatus_termination',
    label: '运单状态 - 终止'
  },
  WAYBILLSTATUS_ERROR: {
    key: 'waybillstatus_error',
    label: '运单状态 - 异常单'
  },
  WAYBILLSTATUS_DATE: {
    key: 'waybillstatus_date',
    label: '运单状态 - 日期选择'
  },
  MYFAVORITES_SET: {
    key: 'myfavorites_set',
    label: '我的收藏 - 设置按钮'
  },
  MYFAVORITES_CONFIRM: {
    key: 'myfavorites_confirm',
    label: '我的收藏 - 确定按钮'
  },
  MYFAVORITES_SET_TIME: {
    key: 'myfavorites_set_time',
    label: '我的收藏 - 收藏所用时间'
  },
  MYFAVORITES_MENUFAVOR: {
    key: 'myfavorites_menufavor',
    label: '我的收藏 - 各菜单的收藏量'
  },
  MYFAVORITES_MENUCLICK: {
    key: 'myfavorites_menuclick',
    label: '我的收藏 - 各菜单的点击量'
  },
  MYFAVORITES_OPEN: {
    key: 'myfavorites_open',
    label: '首页-常用菜单-元素曝光'
  },
  MYFAVORITES_BOOKMARKNOW: {
    key: 'myfavorites_bookmarknow',
    label: '我的收藏 - 立即收藏'
  },
  MYFAVORITES_QUERY: {
    key: 'myfavorites_query',
    label: '我的收藏 - 弹层 - 查询按钮'
  },
  OFFICIALNEWS_TOTAL: {
    key: 'officialnews_total',
    label: '公告信息 - 全部公告'
  },
  OFFICIALNEWS_LINK: {
    key: 'officialnews_link',
    label: '公告信息 - 点击公告链接的总和'
  },
  FAVORITES_SET: {
    key: 'Favorites_set',
    label: '收藏夹-设置按钮'
  },
  FAVORITES_MENU: {
    key: 'Favorites_menu',
    label: '收藏夹- 各菜单的点击量'
  },
  STATIONLETTER_LOGO: {
    key: 'stationletter_logo',
    label: '站内信logo'
  },
  STATIONLETTER_ALLNEWS: {
    key: 'stationletter_allnews',
    label: '全部消息'
  },
  STATIONLETTER_UNREADMESSAGE: {
    key: 'stationletter_unreadmessage',
    label: '未读消息'
  },
  STATIONLETTER_ASREAD: {
    key: 'stationletter_asread',
    label: '全部标为已读'
  },
  STATIONLETTER_DELETETOTAL: {
    key: 'stationletter_deletetotal',
    label: '删除按钮点击量总和'
  },
  HOME_WAYBILL_QUERY: {
    key: 'Home-Waybill',
    label: '首页-运单查询搜索'
  },
  HOME_TCTAB: {
    key: 'Home-TCtab',
    label: '首页-到仓筛选框'
  },
  HOME_ABNORMAL_ORDER_CARD: {
    key: 'Home-AbnormalOrderCard',
    label: '首页-异常订单卡片'
  },
  HOME_RETOBEPACKUP_CARD: {
    key: 'Home-ReToBePackupCard',
    label: '首页-退货待提卡片'
  },
  HOME_INQUIRY_CARD: {
    key: 'Home-InquiryCard',
    label: '首页-询价确认卡片'
  },
  HOME_BACK_TO_OLD: {
    key: 'home_back_to_old',
    label: '首页-返回旧版按钮'
  },
  HOME_MENU_SEARCH: {
    key: 'home_menu_search',
    label: '首页-菜单-搜索'
  },
  HOME_MENU_FAVORITE_LINK: {
    key: 'home_menu_favorite_link',
    label: '首页-收藏菜单-点击'
  },
  COMMON_OVER: {
    key: 'common_over',
    label: '常用菜单 - 关闭'
  },
  COMMON_OPEN: {
    key: 'common_open',
    label: '常用菜单-置顶-元素曝光'
  },
  COMMON_CLICK: {
    key: 'common_click',
    label: '常用菜单-置顶-元素点击 '
  },
  COMMON_MOVE: {
    key: 'common_move',
    label: '常用菜单-置顶-顺序调整 '
  },
  HOVER_CLICK: {
    key: 'hover_click',
    label: '常用菜单-悬浮窗-元素点击 '
  },
  HOVER_OPEN: {
    key: 'hover_open',
    label: '常用菜单-悬浮窗-元素曝光 '
  },
  COMMON_GUIDE: {
    key: 'common_guide',
    label: '新手引导-常驻按钮-点击'
  },
  GUIDE_FIRST: {
    key: 'common_first',
    label: '新手引导-首次曝光'
  },
  GUIDE_OVER: {
    key: 'common_over',
    label: '新手引导-完成-点击'
  },
  GUIDE_IGNORE: {
    key: 'common_ignore',
    label: '新手引导-跳过-点击'
  },
  TOP_CLICK: {
    key: 'top_click',
    label: '顶部导航-已收藏菜单-元素点击'
  },
  TOP_OPEN: {
    key: 'top_open',
    label: '顶部导航-已收藏菜单-元素曝光'
  },
  HOME_CLICK_SLIDER: {
    key: 'home_click_slider',
    label: '首页点击轮播图'
  }
  // TOP_SEARCH: {
  //   key: 'top_search',
  //   label: '顶部菜单栏-搜索-点击'
  // },
  // TOP_RECENTLY: {
  //   key: 'top_recently',
  //   label: '顶部菜单栏-最近访问-点击'
  // },
  // TOP_LIST: {
  //   key: 'top_list',
  //   label: '顶部菜单栏-菜单列表-点击'
  // },
}
